import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=163647a8&scoped=true&lang=pug&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163647a8",
  null
  
)

export default component.exports